import PodcastContentTableCard from './PodcastContentTable';

export default PodcastContentTableCard;
